<template>
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con">

        <div>
          <div class="inner inner_chat">
            <div class="chat">
              <div class="chat_sec">
                <div class="chat_state">
                  <p>상담 운영시간은 10:00 ~ 17:00 입니다.</p>
                </div>
                <ul class="chat_list">
                  <li class="you" v-if="isFirst"><!--상대 대화-->
                    <div class="profile size_xxs">
                      <div class="profile_inner">
                        <img src="@/assets/static/images/logo_image.png">
                      </div>
                    </div>
                    <div class="chat_cont">
                      <div class="chat_txt">
                        <p>안녕하세요?</p>
                        <p>문의하실 서비스를 선택해주세요.</p>
                        <br>
                        <div class="line"></div>
                        <br>
                        <button type="button" class="btnChoiceInquireType" @click="choiceInquireType('ELECT')">전력비 절감 문의</button>
                        <button type="button" class="btnChoiceInquireType" @click="choiceInquireType('LABOR')">노무,인증 문의</button>
                        <button type="button" class="btnChoiceInquireType" @click="choiceInquireType('LAB')">연구소 관리 문의</button>
                        <p>
                          <img src="@/assets/static/images/i_instant.svg" alt="전력비" style="width: 1.5rem; height: 1.5rem; display: inline; vertical-align: top;">
                          <span style="display: inline; vertical-align: top; font-size: 1rem;">보통 몇 분 내 빠른 답변</span>
                        </p>
                      </div>
                    </div>
                  </li>

                  <li v-else
                      :class="{you: message.sendType === 2}"
                      v-for="(message, index) in messageList"
                      :key="index"><!--상대 대화-->
                    <div class="profile size_xxs" v-if="message.sendType === 2">
                      <div class="profile_inner">
                        <img src="@/assets/static/images/logo_image.png">
                      </div>
                    </div>
                    <div class="chat_cont">
                      <div class="chat_txt" v-if="message.messageType === 1">
                        <p>{{ message.message }}</p>
                      </div>
                      <div class="chat_img" v-else-if="message.messageType === 2">
                        <img :src="$Util.loadImage('240', message.message)" @click="download(message)">
                      </div>
                      <p class="time" v-if="message.messageType === 1 || message.messageType === 2">{{ $moment(message.regDate).format('HH:mm') }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div><!--//chat-->
            <div class="chat_input_area">
              <button class="btn_chat_img" @click="showImagePop"></button>
              <textarea placeholder="메시지를 입력해주세요." v-model="messageParams.message" @keydown="keyHandler" @focusin="scrollBottom()" ref="inputMessage" :disabled="isFirst"></textarea>
              <button class="btn_chat_send" @click="sendTemp">전송</button>
              <input type="file" accept="image/*" ref="tempFile" style="display: none" v-on:change="changeSelectFile">
            </div>
          </div>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
export default {
  data: function () {
    return {
      messageInterval: null,
      attachFileUrlPath: '',
      params: {
        file: null,
        fileName: '',
      },
      messageParams: {
        serviceType: 1,
        userNo: this.$store.getters['account/getUserData'].userNo,
        userMessageToken: '',
        messageType: 1,
        sendType: 1,
        message: '',
        lastIndex: 0,
      },
      messageList: [],
      isDuring: false,
      isFirst: true
    }
  },
  created: async function () {
    this.$store.commit('pageStatus/setMessageStatus', false)
  },
  destroyed: function () {
    clearInterval(this.messageInterval)
  },
  methods: {
    choiceInquireType: async function (type) {
      if(this.$moment(new Date().getTime()).format('HH:mm') < '10:00' || this.$moment(new Date().getTime()).format('HH:mm') > '17:00') {
        this.$Util.modalAlert({message: '상담 가능한 시간이 아닙니다.<br />상담 운영시간은 10:00 ~ 17:00 입니다.'})
        return false
      }
      this.messageParams.serviceType = this.$ConstCode.CODE_SERVICE_TYPE[type].value
      this.$store.commit('pageStatus/setMessageStatus', true)
      this.messageParams.userMessageToken = new Date().getTime()
      this.$store.commit('pageStatus/setMessageServiceType', this.messageParams.serviceType)
      this.$store.commit('pageStatus/setUserMessageToken', this.messageParams.userMessageToken)
      await this.getMessageList();

      this.isFirst = false
      this.messageInterval = setInterval(() => {
        this.getMessageList();
      }, 3000)
    },
    getMessageList: async function () {
      if (this.isDuring) {
        return false
      }
      this.isDuring = true
      const res = await this.$CommonSvc.getMessageList(this.messageParams)
      const code = res.code
      const entity = res.entity

      if (code === 1) {
        this.messageList = this.messageList.concat(entity)
        if (!this.$Util.isEmpty(entity)) {
          this.messageParams.lastIndex = entity[entity.length - 1].messageNo
          setTimeout(() => {
            this.scrollBottom()
          }, 100)
        }
      }

      this.isDuring = false
      this.isFirst = false
    },
    scrollBottom: function () {
      setTimeout(() => {
        const container = this.$el.querySelector(".main__con");
        this.$Util.scrollByWrap(container.scrollHeight, container)
      }, 100)
    },
    keyHandler: function (event) {
      if (event.keyCode === 13) {
        if (!event.shiftKey) {
          event.preventDefault();
          this.send()
        }
      }
    },
    showImagePop: function () {
      if (this.isFirst) return false
      const el = this.$refs.tempFile
      el.type = 'file'
      el.click()
    },
    changeSelectFile: async function ($event) {
      const file = $event.target.files[0]
      const res = await this.$CommonSvc.uploadFile({file: file})
      const code = res.code
      const message = res.message
      const entity = res.entity

      // console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.messageParams.messageType = 2
        this.attachFileUrlPath = entity.fileUrlPath
        await this.send()
        this.messageParams.messageType = 1
      }
    },
    sendTemp: function ($event) {
      $event.preventDefault()
      $event.stopPropagation()

      this.$refs.inputMessage.focus()
      this.send()
    },
    send: async function () {
      if (this.messageParams.messageType === 1 && this.messageParams.message === '') {
        return false
      }

      const params = this.$_.clone(this.messageParams)
      if (params.messageType === 2 || params.messageType === 0) {
        params.message = this.attachFileUrlPath
      }

      const res = await this.$CommonSvc.send(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      // console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        await this.getMessageList()
        this.messageParams.message = ''
      }
    },
    download: function (message) {
      const a = document.createElement('a')
      a.href = this.$Util.loadImage('origin', message.message)
      a.download = '첨부파일.png'
      a.target = '_blank'
      a.click()
    }
  }
}
</script>
<style lang="scss" scoped>
.twice {
  button {
    width: calc(50% - 0.5rem);
    display: inline-block;

    &:last-child {
      margin-left: 1rem;
    }
  }
}

$shadow: 0 0 4rem rgba(0, 0, 0, 0.15);
$color-secondary-light: #F4FAFE;
$color-primary-light: #FBEBEA;
$color-primary: #1980C3;
$color-secondary: #FFB100;
$color-error: #ff5a5a;
$color-black: #212121;
$color-blue: #5D7ADE;
$grey-5: #fafafa;
$grey-10: #F5F5F5;
$grey-20: #EEEEEE;
$grey-30: #E0E0E0;
$grey-40: #BDBDBD;
$grey-50: #9E9E9E;
$grey-60: #757575;
$grey-70: #616161;
$grey-80: #424242;
$grey-90: #212121;
$blue-grey-5: #ECEFF1;
$blue-grey-10: #CFD8DC;
$blue-grey-20: #f1f3f5;
$blue-10: #eef8fc;
$blue-20: #d8f0fd;
$blue-30: #8dd5f6;
$yellow-10: #FFFAD8;

@mixin clearfix() {
  & {
    *zoom: 1;
  }
  &:after {
    content: '';
    display: block;
    clear: both;
  }
}

@mixin position($position, $top: 0, $left: 0, $right: null, $bottom: null) {
  position: $position;
  top: $top;
  left: $left;
  right: $right;
  bottom: $bottom;
}

/*프로필 이미지*/
.profile {
  position: relative;

  .profile_inner {
    border-radius: 50%;
    overflow: hidden;
    width: 100%;
    height: 100%;
    //background: $grey-20 url("../images/logo_img_default.png")no-repeat center;
    background-size: 47% auto;;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &.size_xl {
    width: 10rem;
    height: 10rem;
  }

  &.size_l {
    width: 8.6rem;
    height: 8.6rem;
  }

  &.size_m {
    width: 7rem;
    height: 7rem;
  }

  &.size_s {
    width: 6rem;
    height: 6rem;
  }

  &.size_xs {
    width: 4.2rem;
    height: 4.2rem;
  }

  &.size_xxs {
    width: 4rem;
    height: 4rem;
  }

  .btn_profile_add {
    @include position(absolute, null, null, 0, 0);
    //background: #fff url("../images/i_cam_s.png")no-repeat center;
    background-size: 2rem;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    box-shadow: $shadow;
  }
}

.main__con {
  padding-bottom: 3.6rem;
  background-color: #F4FAFE;
}

/*채팅*/
.inner_chat {
  background: $color-secondary-light;
}

.chat {
  padding: 1rem 0 1rem;

  .chat_sec {
    .chat_date {
      text-align: center;
      //background: url("../images/bar_grey35.png")no-repeat center;
      background-size: 100% 1px;
      margin-bottom: 1.5rem;

      p {
        display: inline-block;
        padding: 0 1.2rem;
        font-size: 1.3rem;
        color: $grey-50;
        background: $color-secondary-light;
      }
    }

    .chat_state {
      margin-bottom: 1.8rem;

      p {
        font-size: 1.2rem;
        line-height: 1.6rem;
        text-align: center;
        color: $color-primary;
      }
    }

    .chat_accept {
      text-align: center;
      padding-bottom: 1.8rem;

      button {
        font-size: 1.4rem;
        font-weight: 500;
        height: 3rem;
        width: 5.4rem;
        margin: 0 0.2rem;
        color: #ffffff;
        border-radius: 0.3rem;

        &.btn_prof {
          width: 8.6rem;
          color: $color-primary;
          border: 1px solid $color-primary;
        }

        &.btn_refuse {
          background: $grey-40;
        }

        &.btn_accept {
          background: $color-primary;
        }
      }
    }

    .chat_list {
      padding: 0 1rem;

      li {
        @include clearfix;
        padding-bottom: 1.8rem;

        .chat_cont {
          float: right;
          max-width: 20rem;
          position: relative;

          .time {
            font-size: 1.2rem;
            line-height: 1.5;
            width: 4.6rem;
            text-align: center;
            @include position(absolute, null, -4.6rem, null, 0);
          }

          .chat_txt {
            background: #C4ECFB;
            border-radius: 0.4rem;
            padding: 0.8rem 1rem;

            p {
              font-size: 1.4rem;
              line-height: 1.8rem;
            }

            .btnChoiceInquireType {
              background-color: #EEEEEE;
              padding: 0.5rem;
              margin-bottom: 0.5rem;
              font-size: 1.2rem;
            }
          }
        }

        .chat_img {
          width: 11rem;
          height: 11rem;
          border-radius: 0.4rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        &.you {
          .profile {
            float: left;
            margin-right: 1rem;
          }

          .chat_cont {
            float: left;

            .chat_txt {
              background: #fff;
              box-shadow: $shadow;
            }

            p {
              &.time {
                left: auto;
                right: -4.6rem;
              }
            }
          }
        }
      }
    }
  }
}

/*채팅 입력*/
.chat_input_area {
  @include clearfix;
  @include position(fixed, null, 0, null, 6.45rem);
  z-index: 10;
  width: 100%;
  background: #fff;
  border-bottom: #eee solid 1px;
  //box-shadow: $shadow;
  padding: 0.7rem 1.2rem;

  .btn_chat_img {
    float: left;
    width: 3.8rem;
    height: 3.8rem;
    background: url('~@/assets/static/images/i_pic.png') no-repeat center;
    background-size: 100%;
    margin-right: 0.6rem;
  }

  textarea {
    float: left;
    width: calc(100% - 11rem);
    border: 1px solid $grey-30;
    height: 3.8rem;
    border-radius: 0.3rem;
    font-size: 1.5rem;
    padding: 0.8rem 1.2rem;
  }

  .btn_chat_send {
    float: right;
    width: 6rem;
    height: 3.8rem;
    border-radius: 0.3rem;
    background: $color-primary;
    color: #fff;
    font-size: 1.5rem;
    margin-left: 0.6rem;
  }

  &.chat_often {
    textarea {
      width: calc(100% - 6.6rem);
    }
  }
}
</style>
